<template>
  <BlankPage :status="pageStatus" />
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import commonTool from '@/utils/commonTool';
import comService from '@/services/comService';
import mmsService from '@/services/mmsService';
import BlankPage from '@/components/BlankPage.vue';

export default {
  components: {
    BlankPage,
  },
  data() {
    return {
      pageStatus: 'blank',
      // 公司代碼
      companyId: '',
      // 活動明細代碼
      unionId: '',
      // 會員來源代碼
      memberSourceId: '',
      // 會員lineId
      accountId: '',
      accountType: '',
    };
  },
  created() {
    const vm = this;
    const {
      companyId, unionId, code, ChannelID, isMemberBinding, identifySource,
    } = vm.$route.query;
    this.set({ name: 'companyId', value: companyId });
    sessionStorage.setItem('companyId', companyId);

    mmsService.getQrCodeActivity({ companyId, unionId })
      .toPromise()
      .then((getQrCodeActivityRes) => {
        // 若查不到資料，導向錯誤頁
        if (getQrCodeActivityRes.response.status !== '200') {
          vm.$router.replace({ name: 'Error', params: { status: 'activityNotExist' } });
        }
        const qrCodeActivity = getQrCodeActivityRes.response.data[0];
        vm.companyId = companyId;
        vm.unionId = unionId;
        vm.memberSourceId = qrCodeActivity.bindingMemberSourceId ?? qrCodeActivity.memberSourceId;
        this.set({ name: 'memberSourceId', value: vm.memberSourceId });
        this.set({ name: 'channelId', value: qrCodeActivity.channelId });
        // 取得 Line UserId 後，檢查是否為好友、發訊息
        vm.getLineUserId(companyId, unionId, code, ChannelID, isMemberBinding, identifySource)
          .then(async(userId) => {
            if (isMemberBinding) {
              const res = await this.postCustomerDataBind({
                openid: userId,
                identifySource,
                type: 'LineBind',
                memberSourceID: vm.memberSourceId,
                isSubscribe: true,
              });
              if (res?.response?.status !== '200') {
                vm.$router.replace({ name: 'Error' });
                return;
              }
            }

            switch (qrCodeActivity.typeProcessNo) {
              // 發送訊息
              case 1:
                this.set({ name: 'channelId', value: qrCodeActivity.channelId });
                commonTool.checkFriendAndSendLineMessage(userId, companyId, unionId);
                break;
              // 前往連結
              case 3:
                vm.accountType = vm.accountType ? vm.accountType : 'LineBind';
                commonTool.goToRedirectUrl(qrCodeActivity, vm.companyId, vm.accountType, userId, vm.unionId, vm.memberSourceId, true);
                break;
              default:
                break;
            }
          })
          .catch(() => {
            vm.$router.replace({ name: 'Error' });
          });
      })
      .catch(() => {
        vm.$router.replace({ name: 'Error' });
      });
  },
  methods: {
    ...mapMutations(['set']),
    ...mapActions('mbc', ['postCustomerDataBind']),
    // 取得 Line UserId
    getLineUserId(companyId, unionId, code, ChannelID, isMemberBinding, identifySource) {
      const params = { companyId, unionId, ChannelID };

      if (!!isMemberBinding && !!identifySource) {
        params.isMemberBinding = isMemberBinding;
        params.identifySource = identifySource;
      }
      const redirectQueryString = new URLSearchParams(params).toString();

      const directUrl = `${window.location.origin}${window.location.pathname}?${redirectQueryString}`;
      const body = {
        companyId,
        code,
        directUrl,
        channelID: ChannelID,
      };
      return comService.getLineUserId(body)
        .toPromise()
        .then((res) => res.response.data.userID)
        .catch(() => {
          this.$router.replace({ name: 'Error', params: { status: 'authorization' } });
        });
    },
  },
};
</script>
